import * as React from 'react';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import FontAwesomeIcon from 'react-fontawesome';
import { Link } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { OPEN_ORDER_PATH, RESERVATIONS, TABLES, WORKING_HOURS } from './Constants';
import { resetState } from './actions/Actions';

const HeaderMenu: React.FC = () => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const dispatch = useDispatch();

    const handleClick = React.useCallback(
        (event: React.MouseEvent<HTMLElement>) => {
            setAnchorEl(event.currentTarget);
        },
        [setAnchorEl]
    );

    const handleClose = React.useCallback(() => {
        setAnchorEl(null);
    }, [setAnchorEl]);

    const handleMenuItemClick = React.useCallback(() => {
        dispatch(resetState());
        setAnchorEl(null);
    }, [dispatch]);

    return (
        <div>
            <FontAwesomeIcon
                id='menu-dropdown'
                aria-controls='menu'
                aria-haspopup='true'
                aria-expanded={open ? 'true' : undefined}
                name='bars'
                className='menu-icon'
                onClick={handleClick}
            />
            <Menu
                id='menu'
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
                MenuListProps={{ 'aria-labelledby': 'menu-dropdown' }}>
                <Link className='link' to={OPEN_ORDER_PATH}>
                    <MenuItem className='menu-item' onClick={handleMenuItemClick}>
                        Open orders
                    </MenuItem>
                </Link>
                <Link className='link' to={WORKING_HOURS}>
                    <MenuItem className='menu-item' onClick={handleMenuItemClick}>
                        Working hours
                    </MenuItem>
                </Link>
                <Link className='link' to={TABLES}>
                    <MenuItem className='menu-item' onClick={handleMenuItemClick}>
                        Tables
                    </MenuItem>
                </Link>
                <Link className='link' to={RESERVATIONS}>
                    <MenuItem className='menu-item' onClick={handleMenuItemClick}>
                        Reservations
                    </MenuItem>
                </Link>
            </Menu>
        </div>
    );
};

export default HeaderMenu;
